import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexBreadcrumb',
  setup(__props) {

const defaultBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/defaultBreadcrumb.vue"))
const dividersBreadcrumbs = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/dividersBreadcrumbs.vue"))
const iconsBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/iconsBreadcrumb.vue"))
const navBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/navBreadcrumb.vue"))
const coloredNavigation = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/coloredNavigation.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Breadcrumb"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(defaultBreadcrumb)),
        _createVNode(_unref(dividersBreadcrumbs)),
        _createVNode(_unref(iconsBreadcrumb)),
        _createVNode(_unref(navBreadcrumb)),
        _createVNode(_unref(coloredNavigation))
      ])
    ])
  ], 64))
}
}

})